import { Avatar, Card, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { AppColors } from "../../../common/AppColors";
import { Remove } from "@mui/icons-material";
import { red } from "@mui/material/colors";
import { SupplierModel } from "../../../models/SupplierModel";

interface Props {
  supplier: SupplierModel;
  removeSupplier(index: number): void;
  showSupplierForm(supplier: SupplierModel): void;
  index: number;
}

export const SupplierCard: React.FC<Props> = (props) => {
  let supplier = props.supplier;

  function handleClickRemove(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    props.removeSupplier(props.index);
  }

  return (
    <Grid lg={5} item>
      <div onClick={() => props.showSupplierForm(supplier)}>
        <Card
          sx={{
            p: 2,
            borderRadius: 2,
            background: AppColors.LightColor,
            color: AppColors.Blue,
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textTransform: "capitalize",
            borderColor: AppColors.DarkGray,
            cursor: "pointer",
            "&:hover": {
              background: AppColors.LightGray,
              borderColor: AppColors.Blue,
            },
          }}
        >
          <div>
            <Typography variant="button">{supplier.companyName}</Typography>
            <Typography variant="body2">{supplier.email}</Typography>
          </div>
          <IconButton
            sx={{
              width: 20,
              height: 20,
            }}
            onClick={handleClickRemove}
          >
            <Avatar
              sx={{
                width: 20,
                height: 20,
                bgcolor: red[500],
              }}
            >
              <Remove />
            </Avatar>
          </IconButton>
        </Card>
      </div>
    </Grid>
  );
};
